import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';

import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { useSelector } from 'react-redux';
import ROLE from '../common/role';

const SalesManViewPayments = () => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true); 
    const user = useSelector(state => state?.user?.user);
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    useEffect(() => {
        fetchAllDeptRequests();
    }, [startDate, endDate]); 
    
    const fetchAllDeptRequests = async () => {
        try {
            setLoading(true); 

            const body = {
        
                startDate: startDate ? moment(startDate).toISOString() : '',
                endDate: endDate ? moment(endDate).toISOString() : ''
              };

            let apiUrl;
            let method;

            
            if (user?.type === "Medicine") {
                apiUrl = SummaryApi.salesManViewMedicinePayment.url;
                method = SummaryApi.salesManViewMedicinePayment.method;
            } else if (user?.type === "Cosmetic") {
                apiUrl = SummaryApi.salesManViewCosmeticPayment.url;
                method = SummaryApi.salesManViewCosmeticPayment.method;
            } else {
                throw new Error("Invalid user type");
            }

            
            const response = await fetch(apiUrl, {
                method: method,
                credentials: 'include',
                headers: {
                    "Content-Type": 'application/json'
                  },
                  body: JSON.stringify(body)
            });

            const responseData = await response.json();
            if (responseData.success) {

                const mergedData = user?.type === "Medicine" ? responseData.data.deptRequestList : responseData.data.deptRequestList;



                
                const sortedData = mergedData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setData(sortedData || []);
            } else {
                setError(responseData.message || 'Failed to fetch data');
                setData([]);
            }

        } catch (error) {
            setError('Error fetching dept requests');
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'bg-blue-900 text-white';
            case 'pending':
                return 'bg-yellow-600 text-white';
            case 'rejected':
                return 'bg-red-800 text-white';
            case 'done':
                return 'bg-green-700 text-white';
            default:
                return 'bg-gray-700 text-white';
        }
    };

    return (
        <div className='bg-white pb-4 px-4'>

             {/* Date Filter Section */}
 <div className="flex justify-end items-start mb-4">
                    <div className="text-right">
                      <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها جميع المديونيات </h2>

                      <div className="flex gap-6 justify-end">
                        {/* Start Date */}
                        <div>
                          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                            تاريخ البداية
                          </label>
                          <input
                            type="date"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                          />
                        </div>

                        {/* End Date */}
                        <div>
                          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                            تاريخ النهاية
                          </label>
                          <input
                            type="date"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
            {loading ? (
                <div className="flex justify-center items-center h-64">
                    <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
                </div>
            ) : error ? (
                <p className="text-red-500">{error}</p>
            ) : (
                <>
                    {data.length === 0 ? (
                        <p>لا يوجد مدفوعات حالية</p>
                    ) : (
                        <div className='overflow-x-auto'>
                            <table className='w-full border-collapse border border-gray-300'>
                                <thead>
                                    <tr className='bg-black text-white'>
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">كود المديونية</th>
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">اسم الصيدلية </th>
                                      {/*     <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">البريد الالكتروني </th> */}
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">رقم هاتف الصيدلية </th>
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">عنوان التوصيل</th>
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">تاريخ الدفع</th>
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">الكمية المدفوعة</th>
                                {/*       <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">اجمالى المديونية الحالية</th>*/}
                                        <th className='py-2 px-4 border border-gray-300 text-sm' scope="col">حالة الدفع</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item._id || index} className="min-h-[80px] border-t border-gray-300">
                                            <td className="text-center py-2 px-4 border border-gray-300">#{item.paymentCode}</td>
                                            <td className="text-center py-2 px-6 border border-gray-300">{item.userName || 'N/A'}</td>
                                        {/*     <td className="text-center py-2 px-6 border border-gray-300">{item.email || 'N/A'}</td>*/}
                                            <td className="text-center py-2 px-6 border border-gray-300">{item.userMobileNumber || 'N/A'}</td>
                                            <td className="text-center py-2 px-6 border border-gray-300">{item.userShippingAddress || 'N/A'}</td>
                                            <td className="text-center py-2 px-6 border border-gray-300">{moment(item.createdAt).format('LLL')}</td>
                                        <td className="text-center py-2 px-6 border border-gray-300">
                                         {displayINRCurrency(item.deptQuantity.toString())} {/* Convert deptQuantity to string */}
                                    </td>
                                            <td className={`text-center py-2 px-4 border border-gray-300 ${getStatusColor(item.state)}`}>
                                                {item.state === 'accepted' && 'تم دفع المبلغ الى مندوب المبيعات بنجاح '}
                                                {item.state === 'done' && 'تم تحصيل المبلغ الي الشركة '}
                                                {item.state === 'rejected' && 'عملية مرفوضة'}
                                                {item.state === 'pending' && 'قيد المراجعة'}
                                                {item.state !== 'accepted' && item.state !== 'rejected' && item.state !== 'pending'&& item.state !== 'done' && item.state}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default SalesManViewPayments;
